export const REPLENISHMENT_ROUTE_NAMES = {
  REPLENISHMENT_CATALOG: 'replenishment-catalog',
  REPLENISHMENT_DRAFT_EDIT: 'replenishment-draft-edit',
  REPLENISHMENT_DRAFT_ORDERS: 'replenishment-draft-orders',
  REPLENISHMENT_INBOUND_ORDERS: 'replenishment-inbound-orders',
  REPLENISHMENT_INBOUND_SHIPMENTS_CREATE: 'replenishment-inbound-shipments-create',
  REPLENISHMENT_INBOUND_SHIPMENT_SUMMARY: 'replenishment_inbound_shipment_summary',
  REPLENISHMENT_INVENTORY: 'replenishment-inventory',
  REPLENISHMENT_INVOICE_REPOSITORY: 'replenishment-invoice-repository',
  REPLENISHMENT_ORDERS: 'replenishment-orders',
  REPLENISHMENT_SUGGESTIONS: 'replenishment-suggestions',
};
